import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/searchPOIsFromAddress'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class searchPOIsFromAddressStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "searchPOIsFromAddressStore",
			variables: true,
		})
	}
}

export async function load_searchPOIsFromAddress(params) {
  await initClient()

	const store = new searchPOIsFromAddressStore()

	await store.fetch(params)

	return {
		searchPOIsFromAddress: store,
	}
}
